import PropTypes from "prop-types";
import React from "react";

import useGetRequest from "../../../../../hooks/useGetRequest";
import Loader from "../../../common/Loader";
import AnalysisContentFactory from "../../SingleAnalysisPage/components/AnalysisContentFactory";

function StockPageSectionLatestAnalysis({
  analysisId,
  isInsiderAnalysis = false,
  analysisCategory,
  locale
}) {
  const { response, loading, error } = useGetRequest({
    urlPath:
      analysisId == null
        ? null
        : isInsiderAnalysis
        ? "app.insiderStockAnalysis.get"
        : "app.stockAnalysis.get",
    variables: { stockAnalysisId: analysisId },
    locale,
    skipAccessCheck: true
  });

  if (loading && analysisId != null) {
    return <Loader small />;
  }

  if (!response || error) {
    return null;
  }

  return (
    <AnalysisContentFactory
      response={response}
      analysisCategory={analysisCategory}
      locale={locale}
      compact
    />
  );
}

StockPageSectionLatestAnalysis.propTypes = {
  analysisId: PropTypes.number,
  isInsiderAnalysis: PropTypes.bool,
  analysisCategory: PropTypes.object,
  locale: PropTypes.string
};

export default StockPageSectionLatestAnalysis;
